import { useContext } from 'react';
import { logRejectionsToSentry } from '../../Sentry';
import { useRouteSource } from '../../hooks/useRouteSource';
import { useBrowser } from '../../services/BrowserService';
import { Fetch, useFetch } from '../../services/NetworkService';
import { useEventBus } from '../../util/EventBus';
import { AnalyticsContext } from '../AnalyticsContext';
import { TrackingEvent } from '../TrackingEvent';

export const BookingFormAnalyticsDispatcher = () => {
  const { bus } = useContext(AnalyticsContext);
  const fetch = useFetch();
  const source = useRouteSource() ?? '';
  const referrer = useBrowser().document?.referrer || '';

  useEventBus(bus, ({ name, data }) => {
    const { practiceData } = data;

    if (!practiceData || !practiceData.grpLocId) return;

    if (name === TrackingEvent.BOOKING_FORM_START) {
      const page = translateSourceToPage(source);

      track(fetch, {
        page,
        element: 'Appointment Link',
        event: 'click',
        id: practiceData.grpLocId,
        url: referrer,
      });
    }
  });

  return null;
};

// See public/public/appointment/book/booking_form/index.php:168 in Megatron
const translateSourceToPage = (source: string): string => {
  switch (source) {
    case 'appt-search':
      return 'Landing';
    case 'directory-search':
      return 'Directory';
    case 'profile':
      return 'Practice';
    case 'profile-lightbox':
      return 'Practice-Lightbox';
    case 'nearby-appts':
      return 'Nearby Practice';
    default:
      return source;
  }
};

const track = (fetch: Fetch, body: Record<string, string>) => {
  logRejectionsToSentry('Tracking booking form start event', () =>
    postUrlEncodedData(fetch, '/api/1/track/event', body),
  );
};

const postUrlEncodedData = (fetch: Fetch, path: string, body: Record<string, string>) =>
  fetch(path, {
    method: 'POST',
    body: new URLSearchParams(body),
  });
